import React, { useCallback, useRef } from "react";
import { CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
    container: {
        width:'100%',display:'flex',alignItems:'center',justifyContent:'center', height:'100vh',position:'fixed',top:0,left:0,justifyContent:'center',backgroundColor:'rgba(0,0,0,0.5)',zIndex:99999
    }

  }));
function Loader(props)
{
    const classes = useStyles();
    return props.show?  <>
    <div className={classes.container}>
<CircularProgress color="#fff" size={60} />
</div></>:<></>
}

export default Loader;